import { percent } from "csx"
import { useEffect, useMemo } from "react"
import { getStyleTheme, useStyle, useWorkTaskId } from "@tm/context-distribution"
import { Loader, Scrollbar } from "@tm/controls"
import { bem } from "@tm/utils"
import { channel } from "@tm/models"
import { managerActions, useDutchOrderPlatesStore } from "../../data/state"
import { Plate, Section } from "./_shared"
import Articles from "./components/articles"
import Navigation from "./components/navigation"
import { loadData } from "../../data/helpers/loadData"

export default function Main() {
    const workTaskId = useWorkTaskId()
    const style = useMemo(() => getStyle(), [])

    const { model, loading, savedWorktaskId } = useDutchOrderPlatesStore((state) => ({
        model: state.dutchOrderPlates.model,
        loading: state.dutchOrderPlates.loading,
        savedWorktaskId: state.worktaskId,
    }))

    useEffect(() => {
        if (!workTaskId) {
            return
        }

        if (!savedWorktaskId) {
            managerActions.setWorktaskId(workTaskId)
        }

        if (savedWorktaskId && workTaskId !== savedWorktaskId) {
            managerActions.resetStore()
            managerActions.setWorktaskId(workTaskId)
        }
    }, [workTaskId, savedWorktaskId])

    useEffect(() => {
        const unsub = channel("WORKTASK", workTaskId).subscribe("MODULE/CLOSED", (module) => {
            if (module.includes("dutch-order-plates")) {
                managerActions.resetStore()
            }
        })
        return () => {
            unsub()
        }
    }, [])

    useEffect(() => {
        loadData()
    }, [])

    return (
        <div className={style.wrapper}>
            <Navigation />
            {/* <Plate /> */}
            <Scrollbar>
                <div className={bem(style.cover, loading && "loading")}>
                    {model.formState?.sections?.map((sec, idx) => (
                        <Section key={sec.name} aditionalContent={model.plate && !idx && <Plate plate={model.plate} />} section={sec} />
                    ))}
                </div>
                <Articles />
                {!model.formState?.sections && (
                    <div className="article-list__panel article-list__status">
                        <Loader />
                    </div>
                )}
            </Scrollbar>
        </div>
    )
}

function getStyle() {
    const theme = getStyleTheme()

    return useStyle({
        wrapper: {
            flexBasis: percent(100),
            alignItems: "stretch",
            display: "flex",
            flexDirection: "column",
            padding: theme.margin.m,
        },
        cover: {
            display: "flex",
            flexDirection: "column",
            $nest: {
                "&--loading": {
                    pointerEvents: "none",
                    opacity: theme.opacity.secondary,
                },
            },
        },
    })(Main)
}
